angular.module('FlexyBeautyApp.services')
    .factory('BasicAuthRoleSaleCreationBehavior', ['SaleStatus', 'SalePaymentType', function (SaleStatus, SalePaymentType) {
        return {
            getLeCiseauSaleCreationBehavior: function () {
                return {
                    updateCustomer: false,
                    deleteService: false,
                    addService: false,
                    addItem: false,
                    moveHR: false,
                    updatePrice: false,
                    updatePayment: false,
                    updateDiscount: false,
                    cancelSale: function (saleStatus, payments) {
                        return (saleStatus !== SaleStatus.SOLD) || !(payments.length === 1 && payments[0].type === SalePaymentType.LECISEAU.type);
                    }
                }
            },
            getReserveWithGoogleSaleCreationBehavior: function () {
                return {
                    updateCustomer: false,
                    deleteService: true,
                    addService: true,
                    addItem: true,
                    moveHR: true,
                    updatePrice: true,
                    updatePayment: true,
                    updateDiscount: true,
                    cancelSale: function () {
                        return true;
                    }
                }
            }
        }
    }]);



// WEBPACK FOOTER //
// ./js/services/views/BasicAuthRoleSaleCreationBehavior.js